import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToStatements() {
  return <Redirect to="/db/statements/incomes" />;
}
